import GoogleTagManagerHead from '@reaffiliates/GoogleTagManager/GoogleTagManagerHead';
const ReaffiliatesHead = () => <>
    <GoogleTagManagerHead />
  </>;
export default ReaffiliatesHead;